const {CopyToClipboard} = require('./Component');

module.exports = CopyToClipboard;



// WEBPACK FOOTER //
// ../src/index.js